import $ from 'jquery';
import Swiper from 'swiper/bundle';
import WOW from 'wow.js';
import './components/_lity';
import settings from './components/_settings';
import matchHeight from './components/_matchHeight';
import PartnerSystem from './components/_partner';

settings();
matchHeight();

$(document).ready(function () {
    $('body').addClass('is-loader');

    const wow = new WOW({
        boxClass: 'wow',
        mobile: true,
    });
    wow.init();
});

/* footer
-------------------------------------------*/
$(document).ready(function () {
    var s = $(".c-footer__totop"),
        i = $(".c-footer__widget");
    $(window).scroll(function () {
        var e = $(".c-footer").offset().top - $(window).innerHeight();
        $(window).width() < 991 && (e += 94), $(this).scrollTop() > e ? (s.addClass("absolute"), $(window).width() < 991 && i.addClass("hide") && s.addClass("hide")) : (s.removeClass("absolute"), i.removeClass("hide"), s.removeClass("hide")), 50 < $(this).scrollTop() ? s.addClass("show") : s.removeClass("show"), 50 < $(this).scrollTop() && $(this).scrollTop() < e ? i.addClass("show") : i.removeClass("show")
    }), s.click(function () {
        return $("body, html").animate({
            scrollTop: 0
        }, 500), !1
    })

	$(".c-anchorlink").click(function (e){
		e.preventDefault();
		const target = $(this).attr("href");
		let scrollTop = $(target).offset().top - $('.c-header').innerHeight();
		if ($('#wpadminbar').length) {
			scrollTop -= $('#wpadminbar').innerHeight();
		}
		$('html, body').animate({
			scrollTop: scrollTop
		}, 500);
	});
});

$(window).on('load', function () {
    $('.js-lang-curr').on('click', function () {
        if($(this).hasClass('is-active')){
            $(this).removeClass('is-active');
                        $(this).next()
                                .stop()
                                .slideUp(300);
        }else{
            $(this).addClass('is-active');
            $(this).next()
                    .stop()
                    .slideDown(300);
        }
    });

    // Nav Menu
    //------------------------------------------------------------
    let state = false;
    $('.js-toggle').on('click', function () {
        if (state === false) {
            $(this).addClass('is-active');
            $('.c-header__navwrap').addClass('is-open');
            state = true;
            $('html, body').css('overflow', 'hidden');
        } else {
            $(this).removeClass('is-active');
            $('.c-header__navwrap').removeClass('is-open').addClass('close');
            $('html, body').css('overflow', '');
            setTimeout(function () {
                $('.c-header__navwrap').removeClass('close');
            }, 500);
            state = false;
        }
    });

    $('#primary-menu .menu-item-has-children .arrow_wrap').on('click', function (ev) {
        if ($(window).innerWidth() <= 991) {
            if($(this).hasClass('is-child-show')){
                $(this).removeClass('is-child-show');
                        $(this).next()
                                .stop()
                                .slideUp(300);
            }
            else{
                $(this).addClass('is-child-show');
                        $(this).next()
                                .stop()
                                .slideDown(300);
            }
        }
    });

    /* header fixed
    /*---------------------------------------------------------*/
    var nav = $('.c-header');
    $(window).scroll(function () {
        if ($(window).scrollTop() > 0) {
            nav.addClass('is-fixed');
        } else {
            nav.removeClass('is-fixed');
        }
    });

	// counter js
    //------------------------------------------------------------
	const current_lang = window.document.getElementsByTagName('html')[0].lang;
    $.fn.jQuerySimpleCounter = function (options) {
        let settings = $.extend({
            start: 0,
            end: 100,
            easing: 'swing',
            duration: 4000,
            complete: ''
        }, options);

        let thisElement = $(this);

        $({count: settings.start}).animate({count: settings.end}, {
            duration: settings.duration,
            easing: settings.easing,
            step: function () {
                let mathCount = Math.ceil(this.count);
                thisElement.text(mathCount.toLocaleString(current_lang));
            },
            complete: settings.complete
        });
    };

    $('#number1').jQuerySimpleCounter({end: parseInt($('#number1').text()), duration: 5000});
    $('#number2').jQuerySimpleCounter({end: parseInt($('#number2').text()), duration: 5000});
    $('#number3').jQuerySimpleCounter({end: parseInt($('#number3').text()), duration: 5000});
	$('#number4').jQuerySimpleCounter({end: parseInt($('#number4').text()), duration: 5000});

	// js-swiper-navi
    //------------------------------------------------------------
    const sliderTopNav = new Swiper('.js-swiper-navi .swiper-container', {
        paginationClickable: true,
        resizeObserver: true,
        loop: true,

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },

        breakpoints: {
            1100: {
                slidesPerView: 6,
            },
            600: {
                slidesPerView: 3.4,
            },
            375: {
                slidesPerView: 2.3,
            }
        },
    });

    // slider c-slider
    //------------------------------------------------------------
    $('.c-slider').each(function () {
        new Swiper(this, {
            slidesPerView: 1,
			loop: true,
            effect: 'slider',
            parallax: true,
            speed: 1000,
			touchRatio: 0.5,
            autoplay: {
                delay: 3000,
            },
        });
    });

    // slider
    //------------------------------------------------------------
    $('.js-swiper').each(function () {
        new Swiper(this, {
            slidesPerView: 1,
			loop: true,
            effect: 'slider',
            parallax: true,
            speed: 1000,
            autoplay: {
                delay: 3000,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            pagination: {
                el: '#main_visual_pagination',
                type: 'bullets',
                clickable: true,
            },
        });
    });

    // c-slider2
    //------------------------------------------------------------
    $('.c-slider2').each(function () {
        new Swiper($('.swiper-container', this).get(0), {
            spaceBetween: 40,
            paginationClickable: true,
            resizeObserver: true,
            // slidesPerView: 3,

            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true,
            },

            breakpoints: {
                1100: {
                    slidesPerView: 3,
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
					speed: 1000,
					autoplay: {
						delay: 3000,
					},
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 16,
					speed: 1000,
					autoplay: {
						delay: 3000,
					},
                }
            },
        });
    });

    // c-about__slider js-swiper-list
    //------------------------------------------------------------
    $('.c-about__slider.js-swiper-list').each(function () {
        new Swiper($('.swiper-container', this).get(0), {
            slidesPerView: 1,
            effect: 'slider',
            parallax: true,

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
                1300: {
                    slidesPerView: 3.4,
                },
                600: {
                    slidesPerView: 2.3,
                },
                375: {
                    slidesPerView: 1.6,
                }
            },
        });
    });

     // c-slider3 js-swiper-list
    //------------------------------------------------------------
    let w_dom = $(document).outerWidth();
    let w_container = $('.l-container').outerWidth();

    $('.c-slider3__wrap').css(
        'margin-left',
        (w_dom - w_container) / 2 + 15);

    $('.c-slider3').each(function () {
        new Swiper($('.swiper-container', this).get(0), {
            speed: 1500,
            touchRatio: 0.5,
            autoplay: {
                delay: 2000,
                disableOnInteraction: false,
                pauseOnMouseEnter: true
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            pagination: {
                el: '.c-slider3 .swiper-pagination',
                clickable: true
            },

            breakpoints: {
                1100: {
                    slidesPerView: 3.4,
                    spaceBetween: 75,
                },
                768: {
                    slidesPerView: 2.3,
                    spaceBetween: 75,
                },
                400: {
                    slidesPerView: 1,
                    spaceBetween: 50,
                }
            },

            on: {
                init: function() {
                    let slidesView = Math.round(this.params.slidesPerView);
                    let num = Math.round(this.realIndex + 1) + slidesView;
                    let slideChild = $(
                        '.c-slider3 .swiper-slide:nth-child(n+' + num + ')'
                    );

                    slideChild.find('.c-list3__wrap').addClass('overlay');
                },

                slideChange: function() {
                    let slidesView = Math.round(this.params.slidesPerView);
                    let num = Math.round(this.realIndex + 1) + slidesView;
                    let slide = $('.c-slider3 .swiper-slide');
                    let slideChild = $(
                        '.c-slider3 .swiper-slide:nth-child(n+' + num + ')'
                    );

                    slide.find('.c-list3__wrap').removeClass('overlay');
                    slideChild.find('.c-list3__wrap').addClass('overlay');
                }
            }
        });
    });

	   // c-slider5
    //------------------------------------------------------------
    $('.c-slider5').each(function () {
        const $slider5 = new Swiper(this, {
            spaceBetween: 16,
            slidesPerView: 1,
			loop: true,
			effect: 'slider',
			speed: 1000,
            autoplay: {
                delay: 3000,
            },

            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

            breakpoints: {
				1024: {
                    slidesPerView: 4,
                },
                768: {
                    slidesPerView: 3,
					spaceBetween: 70
                },
                600: {
                    slidesPerView: 2,
                    spaceBetween: 20,
                },
                375: {
                    slidesPerView: 1,
                    spaceBetween: 16,
                }
            },
			on: {
				afterInit: function() {
					this.slideTo(0);
				}
			}
        });
    });

    // js-gallery
    //------------------------------------------------------------
    (function () {
        var swiperThumbnails = new Swiper('.swiper-thumbnails .swiper-container', {
            slidesPerView: 5,
            spaceBetween: 8,
            slideToClickedSlide: true,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });

        var swiperGallery = new Swiper('.swiper-gallery .swiper-container', {
            effect: 'fade',
            thumbs: {
                swiper: swiperThumbnails,
            },
        });
        swiperGallery.controller.control = swiperThumbnails;
    })();

    // js-accordion
    //------------------------------------------------------------
    $('.js-accordion').on('click', function () {
        if($(this).parent().hasClass('is-open')){
            $(this).parent().removeClass('is-open')
            $(this).next()
                .stop()
                .slideUp(300);
        }else{
            $(this).parent().addClass('is-open');
                $(this).next()
                .stop()
                .slideDown(300);
        }
    });

    // js-overview_tab
    //------------------------------------------------------------
    $('.js-overview_wrap').on('click', '.js-overview_tab', function(event){
		if ($(this).hasClass('is-active')) {
			return;
		}
        let parent = $(event.delegateTarget);
        let target = $(this).data('tab');
        parent.find('.js-overview_tab, .js-overview_tab_content').removeClass('is-active');
        parent.find(target).addClass('is-active');
        $(this).addClass('is-active');
        if ($(window).innerWidth() <= 991){
            parent.find('.js-overview_tab_content').slideUp(300);
            parent.find(target).slideDown(300);
        }
    })
    $( window ).on( "resize", function() {
        let overviewTab = $('.js-overview_wrap');
        if (overviewTab.length) {
            let event = $.Event('click');
            event.target = overviewTab.find('.js-overview_tab.is-active')[0];
            overviewTab.trigger(event);
        }

      } );


	// Product archive
	//--------------
	let currentCate = $('#ajax-cat-list li.is-active').data('cate');;
	let isLoading = false;

	$('#ajax-cat-list li a').on('click', function (e) {
		e.preventDefault();
		const cate = parseInt($(this).data('cate'));
		if (cate == currentCate) {
			return;
		}

		$('#ajax-cat-list li').removeClass('is-active');
		$(this).parent('li').addClass('is-active');
		currentCate = cate;

		loadPosts(cate, 1)
	})

	$(document).on('click', '#ajax-list-container .wp-pagenavi a', function(e) {
		e.preventDefault();

		if (isLoading) return;

		let cate = $('#ajax-list-container').data('cat');
		if (!cate) {
			cate = currentCate;
		}
		const page = parseInt($(this).data('page'));

		loadPosts(cate, page);

		// Scroll to top of products
		$('html, body').animate({
			scrollTop: $('#ajax-list-container').offset().top - 150
		}, 500);
	});

	function loadPosts(category, page) {
		isLoading = true;
		$('#ajax-list-container').addClass('loading');

		$.ajax({
			url: WpApp.ajaxurl,
			type: 'POST',
			data: {
				action: 'load_posts',
				nonce: WpApp.nonce,
				category: parseInt(category) > 0 ? category : null,
				page: page,
				post_type: $('#ajax-list-container').data('post-type'),
				taxonomy: $('#ajax-list-container').data('taxonomy'),
			},
			success: function(response) {
				$('#ajax-list-title').html(response.title);
				$('#ajax-list').html(response.list);
				$('#ajax-list-container .wp-pagenavi').replaceWith(response.pagination);
			},
			error: function(xhr, status, error) {
				console.error('Ajax request failed:', error);
				$('#ajax-list').html('<li class="c-list5__item"><p>Something went wrong. Please try again.</p></li>');
			},
			complete: function() {
				isLoading = false;
				$('#ajax-list-container').removeClass('loading');
			}
		});
	}

});

$(document).ready(function() {
	PartnerSystem.init();
});
